import { Routes } from '@angular/router';
import { AsmAuthority } from '@asm/components-core/models/asm-authority';
import { AsmRouteId } from '@asm/components-core/models/asm-route-id';
import { RouterTools, solCanDeactivate } from '@sol/components';
import { routesReports } from './routes-reports';

export const routesPlatform: Routes = [
  // Dashboard - landing page, no specific permission required beyond platform app access
  {
    ...RouterTools.ofLazy(
      AsmRouteId.dashboard,
      () =>
        import('@asm/components-dashboards/components/dashboard/asm-dashboard-page/asm-dashboard-page.component').then(
          m => m.AsmDashboardPageComponent,
        ),
      [],
      '{{LEGACY_ASM_PLATFORM_URL}}',
    ),
    canDeactivate: [solCanDeactivate],
  },

  // Reports — multi-tab shell + sub-routes (see routes-reports.ts)
  ...routesReports,

  // Tracker
  RouterTools.ofLazy(
    AsmRouteId.tracker,
    () =>
      import('@asm/components-tracker/components/tracker/asm-tracker-page/asm-tracker-page.component').then(
        m => m.AsmTrackerPageComponent,
      ),
    [AsmAuthority.MODULE_EASM, AsmAuthority.LIST_OBSERVATIONS],
    '{{LEGACY_ASM_PLATFORM_URL}}/tracker',
  ),
  RouterTools.ofRedirect(AsmRouteId.tracker_detail, AsmRouteId.tracker_detail_overview),
  RouterTools.ofLazy(
    AsmRouteId.tracker_detail_overview,
    () =>
      import('@asm/components-tracker/components/tracker/asm-tracker-detail-page/asm-tracker-detail-overview-page/asm-tracker-detail-overview-page.component').then(
        m => m.AsmTrackerDetailOverviewPageComponent,
      ),
    [AsmAuthority.MODULE_EASM, AsmAuthority.VIEW_OBSERVATION_DETAILS],
  ),
  RouterTools.ofLazy(
    AsmRouteId.tracker_detail_activity,
    () =>
      import('@asm/components-tracker/components/tracker/asm-tracker-detail-page/asm-tracker-detail-activity-page/asm-tracker-detail-activity-page.component').then(
        m => m.AsmTrackerDetailActivityPageComponent,
      ),
    [AsmAuthority.MODULE_EASM, AsmAuthority.VIEW_OBSERVATION_DETAILS],
  ),

  // DRP
  RouterTools.ofRedirect(AsmRouteId.drp, AsmRouteId.drp_credentials),
  RouterTools.ofRedirect(AsmRouteId.drp_credentials, AsmRouteId.atp_exposedAccounts),
  RouterTools.ofLazy(
    AsmRouteId.drp_darkWeb,
    () =>
      import('@asm/components-drp/components/drp/asm-drp-dark-web-page/asm-drp-dark-web-page.component').then(
        m => m.AsmDrpDarkWebPageComponent,
      ),
    [AsmAuthority.MODULE_DARK_WEB, AsmAuthority.LIST_DARK_WEB],
    '{{LEGACY_ASM_PLATFORM_URL}}/dark-web',
  ),
  RouterTools.ofRedirect(AsmRouteId.drp_darkWeb_detail, AsmRouteId.drp_darkWeb_detail_overview),
  RouterTools.ofLazy(
    AsmRouteId.drp_darkWeb_detail_overview,
    () =>
      import('@asm/components-drp/components/drp/asm-drp-dark-web-detail-page/asm-drp-dark-web-detail-overview-page/asm-drp-dark-web-detail-overview-page.component').then(
        m => m.AsmDrpDarkWebDetailOverviewPageComponent,
      ),
    [AsmAuthority.MODULE_DARK_WEB, AsmAuthority.VIEW_DARK_WEB_DETAILS],
  ),
  RouterTools.ofLazy(
    AsmRouteId.drp_darkWeb_detail_activity,
    () =>
      import('@asm/components-drp/components/drp/asm-drp-dark-web-detail-page/asm-drp-dark-web-detail-activity-page/asm-drp-dark-web-detail-activity-page.component').then(
        m => m.AsmDrpDarkWebDetailActivityPageComponent,
      ),
    [AsmAuthority.MODULE_DARK_WEB, AsmAuthority.VIEW_DARK_WEB_DETAILS],
  ),
  RouterTools.ofLazy(
    AsmRouteId.drp_dataLeakage,
    () =>
      import('@asm/components-drp/components/drp/asm-drp-data-leakage-page/asm-drp-data-leakage-page.component').then(
        m => m.AsmDrpDataLeakagePageComponent,
      ),
    [AsmAuthority.MODULE_DATA_LEAKAGE, AsmAuthority.LIST_DATA_LEAKAGE],
    '{{LEGACY_ASM_PLATFORM_URL}}/data-leakage',
  ),
  RouterTools.ofRedirect(AsmRouteId.drp_dataLeakage_detail, AsmRouteId.drp_dataLeakage_detail_overview),
  RouterTools.ofLazy(
    AsmRouteId.drp_dataLeakage_detail_overview,
    () =>
      import('@asm/components-drp/components/drp/asm-drp-data-leakage-detail-page/asm-drp-data-leakage-detail-overview-page/asm-drp-data-leakage-detail-overview-page.component').then(
        m => m.AsmDrpDataLeakageDetailOverviewPageComponent,
      ),
    [AsmAuthority.MODULE_DATA_LEAKAGE, AsmAuthority.VIEW_DATA_LEAKAGE_DETAILS],
  ),
  RouterTools.ofLazy(
    AsmRouteId.drp_dataLeakage_detail_activity,
    () =>
      import('@asm/components-drp/components/drp/asm-drp-data-leakage-detail-page/asm-drp-data-leakage-detail-activity-page/asm-drp-data-leakage-detail-activity-page.component').then(
        m => m.AsmDrpDataLeakageDetailActivityPageComponent,
      ),
    [AsmAuthority.MODULE_DATA_LEAKAGE, AsmAuthority.VIEW_DATA_LEAKAGE_DETAILS],
  ),
  RouterTools.ofLazy(
    AsmRouteId.drp_mobileApps,
    () =>
      import('@asm/components-drp/components/drp/asm-drp-mobile-apps-page/asm-drp-mobile-apps-page.component').then(
        m => m.AsmDrpMobileAppsPageComponent,
      ),
    [AsmAuthority.MODULE_MOBILE, AsmAuthority.LIST_MOBILE],
    '{{LEGACY_ASM_PLATFORM_URL}}/mobile-apps',
  ),
  RouterTools.ofRedirect(AsmRouteId.drp_mobileApps_detail, AsmRouteId.drp_mobileApps_detail_overview),
  RouterTools.ofLazy(
    AsmRouteId.drp_mobileApps_detail_overview,
    () =>
      import('@asm/components-drp/components/drp/asm-drp-mobile-apps-detail-page/asm-drp-mobile-apps-detail-overview-page/asm-drp-mobile-apps-detail-overview-page.component').then(
        m => m.AsmDrpMobileAppsDetailOverviewPageComponent,
      ),
    [AsmAuthority.MODULE_MOBILE, AsmAuthority.VIEW_MOBILE_DETAILS],
  ),
  RouterTools.ofLazy(
    AsmRouteId.drp_mobileApps_detail_activity,
    () =>
      import('@asm/components-drp/components/drp/asm-drp-mobile-apps-detail-page/asm-drp-mobile-apps-detail-activity-page/asm-drp-mobile-apps-detail-activity-page.component').then(
        m => m.AsmDrpMobileAppsDetailActivityPageComponent,
      ),
    [AsmAuthority.MODULE_MOBILE, AsmAuthority.VIEW_MOBILE_DETAILS],
  ),
  RouterTools.ofLazy(
    AsmRouteId.drp_socialMedia,
    () =>
      import('@asm/components-drp/components/drp/asm-drp-social-media-page/asm-drp-social-media-page.component').then(
        m => m.AsmDrpSocialMediaPageComponent,
      ),
    [AsmAuthority.MODULE_SOCIAL_MEDIA, AsmAuthority.LIST_SOCIAL_MEDIA],
    '{{LEGACY_ASM_PLATFORM_URL}}/social-media',
  ),
  RouterTools.ofRedirect(AsmRouteId.drp_socialMedia_detail, AsmRouteId.drp_socialMedia_detail_overview),
  RouterTools.ofLazy(
    AsmRouteId.drp_socialMedia_detail_overview,
    () =>
      import('@asm/components-drp/components/drp/asm-drp-social-media-detail-page/asm-drp-social-media-detail-overview-page/asm-drp-social-media-detail-overview-page.component').then(
        m => m.AsmDrpSocialMediaDetailOverviewPageComponent,
      ),
    [AsmAuthority.MODULE_SOCIAL_MEDIA, AsmAuthority.VIEW_SOCIAL_MEDIA_DETAILS],
  ),
  RouterTools.ofLazy(
    AsmRouteId.drp_socialMedia_detail_activity,
    () =>
      import('@asm/components-drp/components/drp/asm-drp-social-media-detail-page/asm-drp-social-media-detail-activity-page/asm-drp-social-media-detail-activity-page.component').then(
        m => m.AsmDrpSocialMediaDetailActivityPageComponent,
      ),
    [AsmAuthority.MODULE_SOCIAL_MEDIA, AsmAuthority.VIEW_SOCIAL_MEDIA_DETAILS],
  ),

  // Assets
  RouterTools.ofRedirect(AsmRouteId.assets, AsmRouteId.assets_domainDiscovery),
  RouterTools.ofLazy(
    AsmRouteId.assets_domainDiscovery,
    () =>
      import('@asm/components-assets/components/assets/asm-assets-domain-discovery-page/asm-assets-domain-discovery-page.component').then(
        m => m.AsmAssetsDomainDiscoveryPageComponent,
      ),
    [AsmAuthority.MODULE_EASM, AsmAuthority.LIST_DOMAIN_IDENTIFICATION],
    '{{LEGACY_ASM_PLATFORM_URL}}/domain-discovery',
  ),
  RouterTools.ofRedirect(AsmRouteId.assets_domainDiscovery_detail, AsmRouteId.assets_domainDiscovery_detail_overview),
  RouterTools.ofLazy(
    AsmRouteId.assets_domainDiscovery_detail_overview,
    () =>
      import('@asm/components-assets/components/domain-discovery/asm-domain-discovery-detail-page/asm-domain-discovery-overview-page/asm-domain-discovery-overview-page.component').then(
        m => m.AsmDomainDiscoveryOverviewPageComponent,
      ),
    [AsmAuthority.MODULE_EASM, AsmAuthority.VIEW_DOMAIN_IDENTIFICATION_DETAILS],
  ),
  RouterTools.ofLazy(
    AsmRouteId.assets_domainDiscovery_detail_activity,
    () =>
      import('@asm/components-assets/components/domain-discovery/asm-domain-discovery-detail-page/asm-domain-discovery-activity-page/asm-domain-discovery-activity-page.component').then(
        m => m.AsmDomainDiscoveryActivityPageComponent,
      ),
    [AsmAuthority.MODULE_EASM, AsmAuthority.VIEW_DOMAIN_IDENTIFICATION_DETAILS],
  ),
  RouterTools.ofLazy(
    AsmRouteId.assets_domains,
    () =>
      import('@asm/components-assets/components/assets/asm-assets-domains-page/asm-assets-domains-page.component').then(
        m => m.AsmAssetsDomainsPageComponent,
      ),
    [AsmAuthority.MODULE_EASM, AsmAuthority.LIST_DOMAINS],
    '{{LEGACY_ASM_PLATFORM_URL}}/domains',
  ),
  RouterTools.ofRedirect(
    AsmRouteId.assets_domains_detail,
    AsmRouteId.assets_domains_detail_overview,
    '{{LEGACY_ASM_PLATFORM_URL}}/domains/:id',
  ),
  RouterTools.ofLazy(
    AsmRouteId.assets_domains_detail_overview,
    () =>
      import('@asm/components-assets/components/domain/asm-domain-detail-page/asm-domain-overview-page/asm-domain-overview-page.component').then(
        m => m.AsmDomainOverviewPageComponent,
      ),
    [AsmAuthority.MODULE_EASM, AsmAuthority.VIEW_DOMAIN_DETAILS],
  ),
  RouterTools.ofLazy(
    AsmRouteId.assets_domains_detail_findings,
    () =>
      import('@asm/components-assets/components/domain/asm-domain-detail-page/asm-domain-findings-page/asm-domain-findings-page.component').then(
        m => m.AsmDomainFindingsPageComponent,
      ),
    [AsmAuthority.MODULE_EASM, AsmAuthority.VIEW_DOMAIN_DETAILS, AsmAuthority.LIST_OBSERVATIONS],
  ),
  RouterTools.ofLazy(
    AsmRouteId.assets_domains_detail_scoring,
    () =>
      import('@asm/components-assets/components/domain/asm-domain-detail-page/asm-domain-score-page/asm-domain-score-page.component').then(
        m => m.AsmDomainScorePageComponent,
      ),
    [AsmAuthority.MODULE_EASM, AsmAuthority.VIEW_DOMAIN_DETAILS],
  ),
  RouterTools.ofLazy(
    AsmRouteId.assets_websites,
    () =>
      import('@asm/components-assets/components/assets/asm-assets-websites-page/asm-assets-websites-page.component').then(
        m => m.AsmAssetsWebsitesPageComponent,
      ),
    [AsmAuthority.MODULE_EASM, AsmAuthority.LIST_WEBSITES],
    '{{LEGACY_ASM_PLATFORM_URL}}/websites',
  ),
  RouterTools.ofRedirect(
    AsmRouteId.assets_websites_detail,
    AsmRouteId.assets_websites_detail_overview,
    '{{LEGACY_ASM_PLATFORM_URL}}/websites/:id',
  ),
  RouterTools.ofLazy(
    AsmRouteId.assets_websites_detail_overview,
    () =>
      import('@asm/components-assets/components/website/asm-website-detail-page/asm-website-overview-page/asm-website-overview-page.component').then(
        m => m.AsmWebsiteOverviewPageComponent,
      ),
    [AsmAuthority.MODULE_EASM, AsmAuthority.VIEW_WEBSITE_DETAILS],
  ),
  RouterTools.ofLazy(
    AsmRouteId.assets_websites_detail_findings,
    () =>
      import('@asm/components-assets/components/website/asm-website-detail-page/asm-website-findings-page/asm-website-findings-page.component').then(
        m => m.AsmWebsiteFindingsPageComponent,
      ),
    [AsmAuthority.MODULE_EASM, AsmAuthority.VIEW_WEBSITE_DETAILS],
  ),
  RouterTools.ofLazy(
    AsmRouteId.assets_websites_detail_scoring,
    () =>
      import('@asm/components-assets/components/website/asm-website-detail-page/asm-website-score-page/asm-website-score-page.component').then(
        m => m.AsmWebsiteScorePageComponent,
      ),
    [AsmAuthority.MODULE_EASM, AsmAuthority.VIEW_WEBSITE_DETAILS],
  ),
  RouterTools.ofLazy(
    AsmRouteId.assets_hosts,
    () =>
      import('@asm/components-assets/components/assets/asm-assets-hosts-page/asm-assets-hosts-page.component').then(
        m => m.AsmAssetsHostsPageComponent,
      ),
    [AsmAuthority.MODULE_EASM, AsmAuthority.LIST_HOSTS],
    '{{LEGACY_ASM_PLATFORM_URL}}/hosts',
  ),
  RouterTools.ofRedirect(
    AsmRouteId.assets_hosts_detail,
    AsmRouteId.assets_hosts_detail_overview,
    '{{LEGACY_ASM_PLATFORM_URL}}/hosts/:id',
  ),
  RouterTools.ofLazy(
    AsmRouteId.assets_hosts_detail_overview,
    () =>
      import('@asm/components-assets/components/host/asm-host-detail-page/asm-host-overview-page/asm-host-overview-page.component').then(
        m => m.AsmHostOverviewPageComponent,
      ),
    [AsmAuthority.MODULE_EASM, AsmAuthority.VIEW_HOST_DETAILS],
  ),
  RouterTools.ofLazy(
    AsmRouteId.assets_hosts_detail_findings,
    () =>
      import('@asm/components-assets/components/host/asm-host-detail-page/asm-host-findings-page/asm-host-findings-page.component').then(
        m => m.AsmHostFindingsPageComponent,
      ),
    [AsmAuthority.MODULE_EASM, AsmAuthority.VIEW_HOST_DETAILS],
  ),
  RouterTools.ofLazy(
    AsmRouteId.assets_hosts_detail_scoring,
    () =>
      import('@asm/components-assets/components/host/asm-host-detail-page/asm-host-score-page/asm-host-score-page.component').then(
        m => m.AsmHostScorePageComponent,
      ),
    [AsmAuthority.MODULE_EASM, AsmAuthority.VIEW_HOST_DETAILS],
  ),
  RouterTools.ofLazy(
    AsmRouteId.assets_hosts_detail_scanHistory,
    () =>
      import('@asm/components-assets/components/host/asm-host-detail-page/asm-host-scan-history-page/asm-host-scan-history-page.component').then(
        m => m.AsmHostScanHistoryPageComponent,
      ),
    [AsmAuthority.MODULE_EASM, AsmAuthority.VIEW_HOST_DETAILS, AsmAuthority.LIST_HOST_PORT_INFO],
  ),
  RouterTools.ofLazy(
    AsmRouteId.assets_certificates,
    () =>
      import('@asm/components-assets/components/assets/asm-assets-certificates-page/asm-assets-certificates-page.component').then(
        m => m.AsmAssetsCertificatesPageComponent,
      ),
    [AsmAuthority.MODULE_EASM, AsmAuthority.LIST_CERTIFICATES],
    '{{LEGACY_ASM_PLATFORM_URL}}/certificates',
  ),
  RouterTools.ofRedirect(
    AsmRouteId.assets_certificates_detail,
    AsmRouteId.assets_certificates_detail_overview,
    '{{LEGACY_ASM_PLATFORM_URL}}/certificate/:id',
  ),
  RouterTools.ofLazy(
    AsmRouteId.assets_certificates_detail_overview,
    () =>
      import('@asm/components-assets/components/certificate/asm-certificate-detail-page/asm-certificate-overview-page/asm-certificate-overview-page.component').then(
        m => m.AsmCertificateOverviewPageComponent,
      ),
    [AsmAuthority.MODULE_EASM, AsmAuthority.VIEW_CERTIFICATE_DETAILS],
  ),
  RouterTools.ofLazy(
    AsmRouteId.assets_certificates_detail_findings,
    () =>
      import('@asm/components-assets/components/certificate/asm-certificate-detail-page/asm-certificate-findings-page/asm-certificate-findings-page.component').then(
        m => m.AsmCertificateFindingsPageComponent,
      ),
    [AsmAuthority.MODULE_EASM, AsmAuthority.VIEW_CERTIFICATE_DETAILS, AsmAuthority.LIST_OBSERVATIONS],
  ),
  RouterTools.ofLazy(
    AsmRouteId.assets_certificates_detail_scoring,
    () =>
      import('@asm/components-assets/components/certificate/asm-certificate-detail-page/asm-certificate-score-page/asm-certificate-score-page.component').then(
        m => m.AsmCertificateScorePageComponent,
      ),
    [AsmAuthority.MODULE_EASM, AsmAuthority.VIEW_CERTIFICATE_DETAILS],
  ),

  // Insights
  RouterTools.ofRedirect(AsmRouteId.insights, AsmRouteId.insights_reports),
  // The catalog's licence module is `platform`, which the backend never lists in enabled_modules,
  // so none of its three routes carries a MODULE_* authority.
  RouterTools.ofRedirect(AsmRouteId.insights_vulnerability_catalog, AsmRouteId.insights_vulnerability_catalog_list),
  // Two permissions because two endpoints disagree about which one governs the same global read:
  // `/cves/trending` checks LIST_VULNERABILITIES_TRENDING, `/cves/activity` LIST_VULNERABILITIES.
  // Back to one if the backend aligns them.
  RouterTools.ofLazy(
    AsmRouteId.insights_vulnerability_catalog_dashboard,
    () =>
      import('@asm/components-dashboards/components/vulnerability-catalog/asm-cve-catalog-dashboard-page/asm-cve-catalog-dashboard-page.component').then(
        m => m.AsmCveCatalogDashboardPageComponent,
      ),
    [AsmAuthority.LIST_VULNERABILITIES_TRENDING, AsmAuthority.LIST_VULNERABILITIES],
  ),
  RouterTools.ofLazy(
    AsmRouteId.insights_vulnerability_catalog_list,
    () =>
      import('@asm/components-vulnerabilities/components/vulnerability-catalog/asm-cve-catalog-table-page/asm-cve-catalog-table-page.component').then(
        m => m.AsmCveCatalogTablePageComponent,
      ),
    [AsmAuthority.LIST_VULNERABILITIES],
  ),
  RouterTools.ofLazy(
    AsmRouteId.insights_vulnerability_catalog_detail,
    () =>
      import('@asm/components-vulnerabilities/components/vulnerability-catalog/asm-cve-detail-page/asm-cve-detail-page.component').then(
        m => m.AsmCveDetailPageComponent,
      ),
    [AsmAuthority.VIEW_VULNERABILITY_DETAILS],
  ),
  RouterTools.ofLazy(
    AsmRouteId.insights_threat_explorer,
    () =>
      import('@asm/components-vulnerabilities/components/threat-explorer/asm-threat-explorer-assets-page/asm-threat-explorer-assets-page.component').then(
        m => m.AsmThreatExplorerAssetsPageComponent,
      ),
    [AsmAuthority.FEATURE_THREAT_EXPLORER, AsmAuthority.LIST_VULNERABILITIES],
  ),
  RouterTools.ofLazy(
    AsmRouteId.insights_threat_explorer_asset,
    () =>
      import('@asm/components-vulnerabilities/components/threat-explorer/asm-threat-explorer-asset-page/asm-threat-explorer-asset-page.component').then(
        m => m.AsmThreatExplorerAssetPageComponent,
      ),
    [AsmAuthority.FEATURE_THREAT_EXPLORER, AsmAuthority.LIST_VULNERABILITIES],
  ),

  // Administration
  RouterTools.ofRedirect(AsmRouteId.settings, AsmRouteId.administration),
  RouterTools.ofRedirect(AsmRouteId.administration, AsmRouteId.administration_accessManagement),
  RouterTools.ofRedirect(AsmRouteId.administration_accessManagement, AsmRouteId.settings_accessControl_users),
  RouterTools.ofRedirect(AsmRouteId.administration_monitoring, AsmRouteId.settings_auditLogs),
  RouterTools.ofRedirect(AsmRouteId.administration_resources, AsmRouteId.settings_tags),
  RouterTools.ofRedirect(AsmRouteId.settings_scope_settings, AsmRouteId.settings_scope),
  RouterTools.ofRedirect(AsmRouteId.services, AsmRouteId.engagementRequests_overview),
  RouterTools.ofRedirect(AsmRouteId.settings_tags, AsmRouteId.settings_tags_user),
  RouterTools.ofLazy(
    AsmRouteId.settings_tags_user,
    () =>
      import('@asm/components-search/components/settings/asm-tags-page/asm-tags-page.component').then(
        m => m.AsmTagsPageComponent,
      ),
    [AsmAuthority.VIEW_TAGS],
  ),
  RouterTools.ofLazy(
    AsmRouteId.settings_tags_system,
    () =>
      import('@asm/components-search/components/settings/asm-tags-page/asm-tags-page.component').then(
        m => m.AsmTagsPageComponent,
      ),
    [AsmAuthority.VIEW_TAGS],
  ),
  RouterTools.ofRedirect(AsmRouteId.settings_accessControl, AsmRouteId.settings_accessControl_users),
  RouterTools.ofLazy(
    AsmRouteId.settings_accessControl_users,
    () =>
      import('@asm/components-access-management/components/access-management/asm-users-page/asm-users-page.component').then(
        m => m.AsmPartnerUsersPageComponent,
      ),
    [AsmAuthority.VIEW_USERS],
  ),
  RouterTools.ofLazy(
    AsmRouteId.settings_accessControl_roles,
    () =>
      import('@asm/components-access-management/components/access-management/asm-roles-page/asm-roles-page.component').then(
        m => m.AsmPartnerRolesPageComponent,
      ),
    [AsmAuthority.VIEW_ROLES],
  ),
  RouterTools.ofLazy(
    AsmRouteId.settings_auditLogs,
    () =>
      import('@asm/components-platform-administration/components/settings/asm-audit-logs-page/asm-audit-logs-page.component').then(
        m => m.AsmAuditLogsPageComponent,
      ),
    [AsmAuthority.LIST_AUDIT_LOGS],
    '{{LEGACY_ASM_PLATFORM_URL}}/audit-logs',
  ),
  RouterTools.ofLazy(
    AsmRouteId.settings_savedSearches,
    () =>
      import('@asm/components-search/components/settings/asm-saved-searches-page/asm-saved-searches-page.component').then(
        m => m.AsmSavedSearchesPageComponent,
      ),
    [AsmAuthority.VIEW_SAVED_SEARCHES],
  ),
  RouterTools.ofLazy(
    AsmRouteId.settings_automation,
    () =>
      import('@asm/components-automation/components/settings/asm-automation-page/asm-automation-page.component').then(
        m => m.AsmAutomationPageComponent,
      ),
    [AsmAuthority.VIEW_AUTOMATION_RULES],
    '{{LEGACY_ASM_PLATFORM_URL}}/automation',
  ),
  RouterTools.ofLazy(
    AsmRouteId.settings_integrations,
    () =>
      import('@asm/components-integrations/components/settings/asm-integrations-page/asm-integrations-page.component').then(
        m => m.AsmIntegrationsPageComponent,
      ),
    [AsmAuthority.LIST_INTEGRATIONS],
    '{{LEGACY_ASM_PLATFORM_URL}}/integrations',
  ),
  RouterTools.ofLazy(
    AsmRouteId.settings_notifications,
    () =>
      import('@asm/components-notifications/components/settings/asm-notifications-page/asm-notifications-page.component').then(
        m => m.AsmNotificationsPageComponent,
      ),
    [AsmAuthority.VIEW_NOTIFICATION_RULES],
    '{{LEGACY_ASM_PLATFORM_URL}}/notifications',
  ),
  RouterTools.ofRedirect(AsmRouteId.settings_api, AsmRouteId.settings_api_tokens),
  RouterTools.ofLazy(
    AsmRouteId.settings_api_tokens,
    () =>
      import('@asm/components-access-management/components/access-management/asm-api-tokens-page/asm-api-tokens-page.component').then(
        m => m.AsmPartnerApiTokensPageComponent,
      ),
    [AsmAuthority.API_ACCESS],
  ),
  RouterTools.ofLazy(
    AsmRouteId.settings_api_docs,
    () =>
      import('@asm/components-access-management/components/access-management/asm-api-docs-page/asm-api-docs-page.component').then(
        m => m.AsmPartnerApiDocsPageComponent,
      ),
    [AsmAuthority.API_ACCESS],
  ),

  // Scan settings
  RouterTools.ofRedirect(AsmRouteId.settings_scope, AsmRouteId.settings_scope_overview),
  RouterTools.ofLazy(
    AsmRouteId.settings_scope_overview,
    () =>
      import('@asm/components-scopes/components/settings/asm-scope-overview-page/asm-scope-overview-page.component').then(
        m => m.AsmScopeOverviewPageComponent,
      ),
    [AsmAuthority.VIEW_SEEDS],
    '{{LEGACY_ASM_PLATFORM_URL}}/scope',
  ),
  RouterTools.ofLazy(
    AsmRouteId.settings_scope_seeds,
    () =>
      import('@asm/components-scopes/components/settings/asm-scope-seeds-page/asm-scope-seeds-page.component').then(
        m => m.AsmScopeSeedsPageComponent,
      ),
    [AsmAuthority.VIEW_SEEDS],
    '{{LEGACY_ASM_PLATFORM_URL}}/scope',
  ),
  RouterTools.ofLazy(
    AsmRouteId.settings_scope_subscopes,
    () =>
      import('@asm/components-scopes/components/settings/asm-subscopes-page/asm-subscopes-page.component').then(
        m => m.AsmSubscopesPageComponent,
      ),
    [AsmAuthority.VIEW_SUBSCOPES],
    '{{LEGACY_ASM_PLATFORM_URL}}/subscopes',
  ),
  RouterTools.ofLazy(
    AsmRouteId.settings_manualScans,
    () =>
      import('@asm/components-scopes/components/settings/asm-manual-scans-page/asm-manual-scans-page.component').then(
        m => m.AsmManualScansPageComponent,
      ),
    [AsmAuthority.LIST_MANUAL_SCANS],
    '{{LEGACY_ASM_PLATFORM_URL}}/manual-scans',
  ),
  // Engagement-request routes live in routes-engagement-requests.ts (canonical /engagements/* prefix).

  // Usage — Overview (KPIs + consumption charts) and Events tabs render the same component.
  RouterTools.ofRedirect(AsmRouteId.usage, AsmRouteId.usage_overview),
  RouterTools.ofLazy(
    AsmRouteId.usage_overview,
    () =>
      import('@asm/components-usage/components/shared/asm-usage-page/asm-usage-page.component').then(
        m => m.AsmUsagePageComponent,
      ),
    [AsmAuthority.VIEW_BILLING],
  ),
  RouterTools.ofLazy(
    AsmRouteId.usage_events,
    () =>
      import('@asm/components-usage/components/shared/asm-usage-page/asm-usage-page.component').then(
        m => m.AsmUsagePageComponent,
      ),
    [AsmAuthority.VIEW_BILLING],
  ),

  // System
  RouterTools.ofLazy(
    AsmRouteId.downloads,
    () =>
      import('@asm/components-platform-shell/components/downloads/asm-downloads-page/asm-downloads-page.component').then(
        m => m.AsmDownloadsPageComponent,
      ),
    [AsmAuthority.VIEW_DOWNLOADS],
  ),
  RouterTools.ofLazy(
    AsmRouteId.whatsNew,
    () =>
      import('@asm/components-platform-shell/components/whatsnew/asm-whats-new-page/asm-whats-new-page.component').then(
        m => m.AsmWhatsNewPageComponent,
      ),
    [AsmAuthority.VIEW_WHATS_NEW],
    '{{LEGACY_ASM_PLATFORM_URL}}/whats-new',
  ),
  RouterTools.ofLazy(AsmRouteId.decrypt, () =>
    import('@asm/components-scopes/components/decrypt/asm-decrypt-page/asm-decrypt-page.component').then(
      m => m.AsmDecryptPageComponent,
    ),
  ),

  // Account
  RouterTools.ofLazy(
    AsmRouteId.account_documentation,
    () =>
      import('@asm/components-platform-shell/components/docs/asm-docs-page/asm-docs-page.component').then(
        m => m.AsmDocsPageComponent,
      ),
    [[AsmAuthority.VIEW_USER_WIKI_DOCS, AsmAuthority.VIEW_PARTNER_WIKI_DOCS], AsmAuthority.VIEW_PLATFORM_APP],
    '{{LEGACY_ASM_PLATFORM_URL}}/docs',
  ),
];
